import { z } from "zod";
import { ActorRefSchema, AssetRefSchema, MoneySchema, TimestampSchema } from "./common.js";
import { IdSchema } from "./ids.js";
export const INTERCOMPANY_KINDS = [
    "message",
    "request",
    "offer",
    "acceptance",
    "rejection",
    "delivery",
];
export const InterCompanyKindSchema = z.enum(INTERCOMPANY_KINDS);
/**
 * A formal letter between company inboxes (DESIGN §4.1). Received content is untrusted data,
 * never instructions. Attachments are explicit copies, never live references.
 */
export const InterCompanyMessageSchema = z.object({
    id: IdSchema,
    threadId: IdSchema,
    from: z.object({ companyId: IdSchema, actor: ActorRefSchema }),
    to: z.object({ companyId: IdSchema, floorId: IdSchema.optional() }),
    kind: InterCompanyKindSchema,
    subject: z.string().min(1),
    body: z.string(),
    attachments: z.array(AssetRefSchema),
    terms: z
        .object({
        scope: z.string().min(1),
        deadline: TimestampSchema.optional(),
        price: MoneySchema.optional(),
    })
        .optional(),
    inReplyTo: IdSchema.optional(),
    sentAt: TimestampSchema,
});
/** Per-company setting `intercompany.approval`; default "none". */
export const InterCompanyApprovalSchema = z.enum(["none", "contracts", "all"]);
export const INTERCOMPANY_APPROVAL_DEFAULT = "none";
export const INTERCOMPANY_PERMISSIONS = {
    send: "intercompany.send",
    accept: "intercompany.accept",
    signContract: "intercompany.contract.sign",
    block: "intercompany.block",
};
/** Control-plane routing log row: metadata and a content hash, never the body. */
export const RoutingRecordSchema = z.object({
    messageId: IdSchema,
    threadId: IdSchema,
    fromCompanyId: IdSchema,
    toCompanyId: IdSchema,
    kind: InterCompanyKindSchema,
    /** sha256 hex of the canonical JSON of the message. */
    contentHash: z.string().regex(/^[0-9a-f]{64}$/),
    at: TimestampSchema,
    outcome: z.enum(["delivered", "blocked", "rate_limited", "unknown_company", "failed"]),
});
//# sourceMappingURL=intercompany.js.map